import { format }from 'date-fns'
import Parse from '@/parse'
const Event = Parse.Object.extend('Event')

export default {
  initForm ({ state, getters, commit }) {
    commit('setName', state.event.get('name'))
    commit('setPlace', state.event.get('place'))
    const date = state.event.get('date')
    commit('setYear', format(date, 'YYYY'))
    commit('setMonth', format(date, 'M'))
    commit('setDay', format(date, 'D'))
    commit('setStartHour', getters.splitHour(state.event.get('start')))
    commit('setStartMinute', getters.splitMinute(state.event.get('start')))
    commit('setFinishHour', getters.splitHour(state.event.get('finish')))
    commit('setFinishMinute', getters.splitMinute(state.event.get('finish')))
    commit('setCloseTime', state.event.get('closeTime'))
    commit('setContent', state.event.get('content'))
    commit('setTimeZone', state.event.get('timezone'))
    commit('setAutoEntry', state.event.get('autoEntry'))
  },

  resetForm ({ commit }) {
    commit('setName', '')
    commit('setPlace', '')
    const date = new Date()
    commit('setYear', format(date, 'YYYY'))
    commit('setMonth', format(date, 'M'))
    commit('setDay', format(date, 'D'))
    commit('setStartHour', 0)
    commit('setStartMinute', 0)
    commit('setFinishHour', 0)
    commit('setFinishMinute', 0)
    commit('setCloseTime', 0)
    commit('setContent', '')
    commit('setTimeZone', 'Asia/Tokyo')
    commit('setAutoEntry', false)
  },

  retrieveEvents ({ commit }) {
    var query = new Parse.Query(Event)
    query.descending('createdAt')
    query.find().then((results) => {
      commit('setEvents', results)
    }).catch((error) => {
      console.log(error)
    })
  },

  async getEntries ({ commit }) {
    let query = new Parse.Query('Entry')
    query.include('event', 'allowed')
    query.find().then((results) => {
      let entries = {}

      // イベントID毎に参加者を配列化
      results.forEach((entry) => {
        let event = entry.get('event')

        if (!entries[event.id]) {
          entries[event.id] = []
        }

        entries[event.id].push(entry)
      })

      commit('setEntries', entries)
    }).catch((error) => {
      console.log(error)
    })
  },

  async getEvent({ commit }, id) {
    let query = new Parse.Query(Event)
    try {
      let object = await query.get(id)
      commit('setEvent', object)
    } catch (error) {
      console.log(error)
    }
  },

  async saveEvent({ state, getters, dispatch }, action) {
    var event = state.event
    if (action === 'new' || action === 'auto_entry_new') {
      event = new Event()
      if (action === 'auto_entry_new') {
        event.set('autoEntry', true)
      }
    }
    event.set('name', state.name)
    event.set('place', state.place)
    event.set('date', getters.dateFormat)
    event.set('start', getters.startFormat)
    event.set('finish', getters.finishFormat)
    event.set('closeTime', Number(state.closeTime))
    event.set('content', state.content)
    event.set('timezone', state.timezone)

    try {
      if (getters.isInvalidStart) {
        throw new Parse.Error(1003, 'over finish time')
      }
      await event.save()
      let snackBarMessage = 'イベント情報を更新しました。'
      if (action === 'new' || action === 'auto_entry_new') {
        snackBarMessage = 'イベントを作成しました。'
      }
      return snackBarMessage
    } catch (error) {
      dispatch(
        'snackBar/addMessage',
        error,
        { root: true }
      )
    }
  },

  deleteEvent({ state, commit }) {
    state.event.destroy().then(() => {
      commit(
        'snackBar/addMessage',
        'イベントを削除しました。',
        { root: true }
      )
    })
  },

  async close ({ dispatch }, event) {
    try {
      const message = await Parse.Cloud.run('hasEntry', {
        eventId: event.id
      })

      if (message) {
        return message
      }

      const result = await Parse.Cloud.run('closeEvent', {
        eventId: event.id
      })
      dispatch('retrieveEvents')
      return result
    } catch (error) {
      console.log(error)
    }
  }
}
